import { SVGProps } from 'react';

export function MaterialHeart({
	fill = '#ffffff',
	width = '24',
	height = '24',
	...props
}: SVGProps<SVGSVGElement>) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g>
				<path
					d="M11.961 22.7789C11.5953 22.7868 11.2356 22.6859 10.9286 22.4893C7.0997 19.9184 4.47829 17.5717 2.43029 14.8816C1.33039 13.4334 0.0592844 11.4507 0.00221667 8.94778C-0.0357867 7.47159 0.41576 6.0236 1.28803 4.82457C2.16031 3.62553 3.40544 2.74122 4.83364 2.30642C7.40049 1.51054 10.2047 2.30253 12.005 4.24678C12.877 3.2649 14.0298 2.56732 15.3113 2.24612C17.7848 1.61559 20.3036 2.29098 22.0405 4.04428C23.7889 5.81029 24.4175 8.3326 23.7224 10.792C23.0453 13.1911 21.5771 15.0264 20.2298 16.5054C18.3036 18.6188 15.9871 20.5617 13.149 22.4444C12.7939 22.6666 12.3814 22.7828 11.961 22.7789Z"
					fill={fill}
					width={width}
					height={height}
				/>
			</g>
		</svg>
	);
}
